import { HvacGroup, ProjectReport, ProjectReportHvac } from '@belimo-retrofit-portal/logic';
import { pipe } from 'fp-ts/function';
import * as A from 'fp-ts/ReadonlyArray';
import * as R from 'fp-ts/ReadonlyRecord';
import { Project } from 'src/modules/common/types/Project';
import { HVAC_AREA_MAP } from 'src/modules/hvac/constants/area';
import { HVAC_GROUP_AREAS, HVAC_GROUP_LIST } from 'src/modules/hvac/constants/group';
import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';

export const resolveReportHvac = (
  formData: HvacFormData,
  previous: Project,
): ProjectReport => ({
  ...previous.data.report,
  hvac: pipe(
    HVAC_GROUP_LIST,
    A.map((groupKey) => {
      const reportGroups = previous.data.report.hvac.filter((it) => it.group === groupKey);
      return pipe(
        formData.assessment.groups[groupKey],
        A.mapWithIndex((groupIndex): ProjectReportHvac => {
          const reportGroup = reportGroups[groupIndex];
          if (reportGroup == null) {
            return {
              enabled: true,
              group: groupKey,

              showSchemas: groupKey === HvacGroup.EMISSION,
              showDetails: true,
              showComments: true,

              showAreas: pipe(
                HVAC_AREA_MAP,
                R.mapWithIndex((areaKey) => {
                  if (!HVAC_GROUP_AREAS[groupKey].includes(areaKey)) {
                    return false;
                  }

                  return formData.assessment.areas[areaKey].enabled;
                }),
              ),
            };
          }

          return {
            ...reportGroup,
            showAreas: pipe(
              HVAC_AREA_MAP,
              R.mapWithIndex((areaKey) => {
                if (!HVAC_GROUP_AREAS[groupKey].includes(areaKey)) {
                  return false;
                }

                const nextAreaEnabled = formData.assessment.areas[areaKey].enabled;
                const prevAreaEnabled = previous.data.hvac.areas[areaKey].enabled;

                return nextAreaEnabled !== prevAreaEnabled
                  ? nextAreaEnabled
                  : prevAreaEnabled;
              }),
            ),
          };
        }),
      );
    }),
    A.flatten,
  ),
});
